export default class Password {
  constructor(contents) {
    this.eye = contents.querySelector('._eye');
    this.input = contents.getElementsByTagName("input")[0];

    this.isPassword = true;

    this.setup()
  }

  setup () {
    this.eye.addEventListener('click', (event) => {
      if(this.isPassword)
      {
        this.isPassword = false;
        this.input.type = "text";
        this.eye.classList.add("off");

      }
      else
      {
        this.isPassword = true;
        this.input.type = "password";
        this.eye.classList.remove("off");
      }
    });
  }

}